export function horizontalScrollForTables() {
    const tables = document.querySelectorAll<HTMLTableElement>('table');
    tables.forEach(table => {
        const parentDiv = table.closest('div');
        if (parentDiv && !parentDiv.classList.contains('overflow-x-auto')) {
            parentDiv.classList.add('overflow-x-auto');
        }
    });
}